<feedback-top-bar *ngIf="router && router.url !== '/' && !router.url.includes('details')"></feedback-top-bar>
<router-outlet></router-outlet>
<feedback-footer  *ngIf="router && router.url !== '/' && !router.url.includes('details') && innerWidth > 768"></feedback-footer>
